import React, { useEffect, useState } from "react";
import { getMyLoanApplications } from "../../API/Api";

const LoanAssistance = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const fetchLoans = async () => {
      try {
        setLoading(true);
        const response = await getMyLoanApplications();
        if (response.status) {
          setLoans(response.data);
        } else {
          setError("Failed to fetch loan applications");
        }
      } catch (err) {
        setError(err.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchLoans();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="p-4">
      <table className="order-table-ord font-poppins w-full">
        <thead>
          <tr className="bg-gray-100">
            <th className="order-col-ord p-3 text-left">Loan Reference Number</th>
            <th className="order-col-ord p-3 text-left">Bank Name</th>
            <th className="order-col-ord p-3 text-left">Name</th>
            <th className="order-col-ord p-3 text-left">Mobile</th>
            <th className="order-col-ord p-3 text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          {loans.map((loan) => (
            <tr key={loan.id} className="border-b hover:bg-gray-50">
              <td className="p-3">{loan.loan_reference_number}</td>
              <td className="p-3">{loan.bank_selected}</td>
              <td className="p-3">{loan.full_name}</td>
              <td className="p-3">{loan.mobile}</td>
              <td className="p-3">
                <span
                  className={`px-2 py-1 rounded-full text-xs ${
                    loan.status === "approved"
                      ? "bg-green-100 text-green-800"
                      : loan.status === "rejected"
                      ? "bg-red-100 text-red-800"
                      : "bg-yellow-100 text-yellow-800"
                  }`}
                >
                  {loan.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LoanAssistance;
